angular.module('iqxCore')
.controller('RegisterLegacyCtrl', function ($scope, FormSvc, QuestionnaireSvc, ApplicationSvc, $location, LanguageSvc, $routeParams, ApiSvc, loginSvc) {

    if (ApplicationSvc.params.REGISTRATIONTYPE == "wizard") { // if its set to normal registration - redirect
        ApplicationSvc.navigate("register")      
    }

    var testData={Email:'xxx@xxx.co.uk',
                  RepeatEmail:'xxx@xxx.co.uk',
                  Password:'abcdefA.1',
                  RepeatPassword:'abcdefA.1',
                  Forenames:'Herbert Horace',
                  Surname:'Fflowers-Fothergill',
                  DOB:'xxx 15/05/1955',
                  Addr1:'The Hole',
                  Postcode:'TD99 9JT'
                  } // Assign to fetchAPI for easy testing - passes all the validations
  
    $scope.theRecord={}
    $scope.requiredFields={
      DOB:true,
      NI:false,
      MOBILE:false,
      PHONE:false
    }

    FormSvc.setOptions($scope,{
      fetchAPI:{}, // No data fetch - initialise with empty record
      saveAPI:'register/candidate', 
      notLoggedIn:true, // New candidate so obviously not yet logged in
      autoEdit:true, // Switch form straight to edit mode
      saveCleanFields:true, // All fields sent, whether or not dirty
      savePrefix:'p',
      dateFields:['DOB'],
      questionnaire:{
        tagTarget:'tags',
        tagLocation:'P',
        postVar:'qanswers'
        }
      })

    var lang = LanguageSvc.lang    
    $scope.saveButtonCaption=lang.pages.candregister.buttoncaption
    
    $scope.update=function () {  // Over-ride the default update() called by the Register button
      return FormSvc.update($scope,true)  // Save only - do not do the fetch
        .then(function(res) {
          ApplicationSvc.isEditing=false
          loginSvc.setLoggedIn(res)
          .then(function(){
            $location.path('/canddepartments')  // Add departmental registration details     
          })
        })
	    }

    $scope.getRequiredFields=function(){
      return ApiSvc.fetch($scope,{
        fetchAPI:'callresult_/NetGetRegRequired',
        fetchTarget:'requiredFields',
        multiRow:false,
        notLoggedIn:true
      })
        .then(function(){
          $scope.requiredFields = JSON.parse($scope.requiredFields.JSON)
        })
    }
      
    $scope.$watch('theRecord.Email', function(newValue, oldValue) {
      $scope.theRecord.UserName=newValue  // Email address is default username which they can then edit
      })

    $scope.passwordOpts()
    $scope.getRequiredFields()
    .then(function(){
      $scope.fetch()  // Initialise
    })    
})
